import { apiSlice } from '@/features/api/apiSlice';

export type AuditEntry = {
  id: string;
  action: string;
  entityType: string;
  entityId: string | null;
  actor: { id: string; email: string | null; name: string | null } | null;
  payloadDiff: unknown;
  createdAt: string;
};

export const auditApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listAudit: b.query<
      AuditEntry[],
      { entityType?: string; entityId?: string; limit?: number } | void
    >({
      query: (arg) => {
        const p = new URLSearchParams();
        if (arg?.entityType) p.set('entityType', arg.entityType);
        if (arg?.entityId) p.set('entityId', arg.entityId);
        if (arg?.limit) p.set('limit', String(arg.limit));
        return `/audit?${p.toString()}`;
      },
    }),
  }),
});

export const { useListAuditQuery } = auditApi;
